import { historie } from '../history.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { palette } from '../palette.js';

export const paint = bead => {

    let initialStyle = bead.style;

    if (palette.activeStyleId === null && !b3.store.state.beadSoupActive) {
        console.error('no active style found')
    }

    let newStyle = palette.activeStyleId || -1;

    let myBeadArray = [...Array(settings.columns)].map(()=>Array(settings.rows));

    beads.arr.forEach(_bead => {
        myBeadArray[_bead.column][_bead.row] = {
            style: _bead.style,
            row: _bead.row,
            column: _bead.column,
        };
    });

    class Bar {
        constructor (column, row, parent=null) {
            this.length = 1;
            this.left = column;
            this.right = column;
            this.row = row;
            this.parent = parent;
            this.extend();
        }

        extend () {
            let shouldExtend = true;
            while (shouldExtend) {
                if (this.left > 0) {
                    if (myBeadArray[this.left - 1][this.row].style == initialStyle) {
                        this.left--;
                        this.length++;
                    } else {
                        shouldExtend = false;
                    }
                } else {
                    shouldExtend = false;
                }
            }

            shouldExtend = true;
            while (shouldExtend) {
                if (this.right < settings.columns - 1) {
                    if (myBeadArray[this.right + 1][this.row].style == initialStyle) {
                        this.right++;
                        this.length++;
                    } else {
                        shouldExtend = false;
                    }
                } else {
                    shouldExtend = false;
                }
            }
        }

        lookDown (column) {
            if (myBeadArray[column][this.row + 1].style == initialStyle) {
                let bar = new Bar(column, this.row + 1, this);
                bars.push(bar);
                return bar.right + 2;
            } else {
                return column + 1;
            }
        }

        lookUp (column) {
            if (myBeadArray[column][this.row - 1].style == initialStyle) {
                let bar = new Bar(column, this.row - 1, this);
                bars.push(bar);
                return bar.right + 2;
            } else {
                return column + 1;
            }
        }

        paint () {
            for (let i = this.left; i <= this.right; i++) {
                myBeadArray[i][this.row].style = newStyle;
                beads.addColor(beads.findBead(i, this.row));
            }
        }
    }

    let bars = [];

    bars.push(new Bar(bead.column, bead.row)); // seed of first bar

    let notDone = true;
    let currentBar, currentColumn;

    let checkOffsetBead = settings.pattern.noOffsetInPaint ? false : true;
    let diffAbove;
    let diffBelow;
    let offsetAbove;
    let offsetBelow;

    while (notDone) {
        currentBar = bars.pop();
        if (currentBar === undefined) { // if there are no more bars to process, finish
            notDone = false;
        } else {

            diffAbove = beads.rowOffset[currentBar.row - 1] - beads.rowOffset[currentBar.row];
            diffBelow = beads.rowOffset[currentBar.row + 1] - beads.rowOffset[currentBar.row];

            offsetAbove = (diffAbove == 1) ? 1 : 0; // need this to ensure check forks to the right
            offsetBelow = (diffBelow == 1) ? 1 : 0;

            // consider below

            if (currentBar.row < settings.rows - 1) {
                let currentColumn = currentBar.left;
                while (currentColumn <= currentBar.right + offsetBelow) {
                    if (currentBar.parent) {
                        if (currentBar.parent.row == currentBar.row + 1) {
                            if (currentColumn == currentBar.parent.left) {
                                currentColumn += currentBar.parent.length + 1;
                                continue;
                            }
                        }
                    }

                    // process extra bead if the row is offset

                    if (checkOffsetBead) {
                        if (currentColumn == currentBar.left &&
                            (diffBelow == -1) &&
                            (currentColumn > 0)) {
                            currentBar.lookDown(currentColumn - 1);
                        }
                        if (currentColumn == currentBar.right &&
                            (diffBelow == 1) &&
                            (currentColumn < settings.columns - 1)) {
                            currentBar.lookDown(currentColumn + 1);
                        }
                    }

                    if (currentColumn < settings.columns) {
                        currentColumn = currentBar.lookDown(currentColumn);
                    } else {
                        currentColumn++;
                    }
                }
            }

            // consider above

            if (currentBar.row > 0) {
                currentColumn = currentBar.left;
                while (currentColumn <= currentBar.right + offsetAbove) {
                    if (currentBar.parent) {
                        if (currentBar.parent.row == currentBar.row - 1) {
                            if (currentColumn == currentBar.parent.left) {
                                currentColumn += currentBar.parent.length + 1;
                                continue;
                            }
                        }
                    }

                    // process extra bead if the row is offset
                    if (checkOffsetBead) {
                        if (currentColumn == currentBar.left &&
                            (diffAbove == -1) &&
                            (currentColumn > 0)) {
                            currentBar.lookUp(currentColumn - 1);
                        }
                        if (currentColumn == currentBar.right &&
                            (diffAbove == 1) &&
                            (currentColumn < settings.columns - 1)) {
                            currentBar.lookUp(currentColumn + 1);
                        }
                    }
                    if (currentColumn < settings.columns) {
                        currentColumn = currentBar.lookUp(currentColumn);
                    } else {
                        currentColumn++;
                    }
                }
            }
            // paint the bar
            currentBar.paint();
        }
    }

    myBeadArray = [];
    document.body.style.cursor  = 'default';
    historie.addAction();

};
